import React from 'react';
import {
  StatusInfoWrapper,
  StatusText,
  WarningWrapper,
} from './StatusInfo.styles';

export const StatusInfo = ({ expiryStatus }: any) => {
  const { expired, date } = expiryStatus;
  return (
    <StatusInfoWrapper expired={expired} data-testid="status-info">
      {expired ? (
        <WarningWrapper>Offer Expired</WarningWrapper>
      ) : (
        <StatusText>{`Expires ${date}`}</StatusText>
      )}
    </StatusInfoWrapper>
  );
};
